const TspActionTypes = {
  FETCH_TSP_REQUEST: 'FETCH_TSP_REQUEST',
  FETCH_TSP_SUCCESS: 'FETCH_TSP_SUCCESS',
  FETCH_TSP_FAILURE: 'FETCH_TSP_FAILURE',
  SELECT_TSP: 'SELECT_TSP'
}

export default TspActionTypes